import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegCircle } from "react-icons/fa";

import DisplayQuestionCard from "../../../sub-components/managerQueSub/DisplayQuestionCard";
import CreateQueBoilerPlateCard from "../../../sub-components/managerQueSub/CreateQueBoilerPlateCard";
import CreateQuestionnaireTitle from "../../../../InterstellrComponents/CreateQuestionnaireTitle";
import axios from "axios";
import { CREATE_QUESTIONNIARE } from "../../../../Routes";
import { generateURLOptions } from "../../../../URLOptions";

const createEmptyQuestion = () => ({
  id: crypto.randomUUID(),
  type: "single", // "single" | "multi" | "text"
  text: "",
  answers: [{ id: crypto.randomUUID(), text: "" }],
});

const OrganisationCreateQuestionnaire = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [endDate, setEndDate] = useState(null);

  // FINAL SOURCE OF TRUTH
  const [questions, setQuestions] = useState([createEmptyQuestion()]);

  /* -----------------------------
     Question helpers
  ------------------------------*/

  const updateQuestion = (updatedQuestion) => {
    setQuestions((prev) =>
      prev.map((q) => (q.id === updatedQuestion.id ? updatedQuestion : q)),
    );
  };

  const removeQuestion = (id) => {
    setQuestions((prev) =>
      prev.length > 1 ? prev.filter((q) => q.id !== id) : prev,
    );
  };

  const addQuestion = () => {
    setQuestions((prev) => [...prev, createEmptyQuestion()]);
  };

  /* -----------------------------
     Submission
  ------------------------------*/

  const buildPayload = (isDraft) => {
    return {
      title,
      endTime: endDate.toISOString(),
      draft: isDraft,
      questions: questions
        .filter((q) => q.text.trim())
        .map((q) => ({
          title: q.text,
          type:
            q.type === "mood"
              ? 0
              : q.type === "single"
                ? 1
                : q.type === "multi"
                  ? 2
                  : 3,
          options: q.type === "text" ? [] : q.answers.map((a) => a.text),
        })),
    };
  };

  const submitDraft = async () => {
    if (!endDate) {
      return alert("Please select an End Date");
    }
    const payload = buildPayload(true);
    console.log("DRAFT PAYLOAD:", payload);

    const response = await axios.post(CREATE_QUESTIONNIARE, payload, {
      headers: generateURLOptions(),
    });

    console.log("RESPONSE IS: ", response.data);

    if (response.data.success == false) {
      return alert(response?.message ?? "");
    }

    navigate("/manager/questionnaires");
  };

  const submitQuestionnaire = async () => {
    if (!endDate) {
      return alert("Please select an End Date");
    }
    const payload = buildPayload(false);
    console.log("SUBMIT PAYLOAD:", payload);

    const response = await axios.post(CREATE_QUESTIONNIARE, payload, {
      headers: generateURLOptions(),
    });

    console.log("RESPONSE IS: ", response.data);

    if (response.data.success == false) {
      return alert(response?.message ?? "");
    }

    navigate("/manager/questionnaires");
  };

  return (
    <div
      className="min-h-screen w-full"
      style={{
        background:
          "linear-gradient(45deg, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0.85) 45%, rgba(81,83,245,1) 150%)",
      }}
    >
      <div className="container mx-auto pt-24 px-6 md:px-0">
        {/* Header */}
        <div className="flex flex-col md:flex-row items-start md:items-center mb-8">
          <h1 className="text-3xl font-semibold text-black">
            Create a Questionnaire
          </h1>

          <div className="flex-1" />

          <div className="flex gap-3 mt-4 md:mt-0">
            <button
              onClick={() => navigate("/manager")}
              className="px-5 py-3 rounded-xl border border-slate-300 text-slate-700 font-medium hover:bg-slate-100"
            >
              Discard
            </button>

            <button
              onClick={submitDraft}
              className="px-5 py-3 rounded-xl bg-slate-200 text-black font-medium hover:bg-slate-300"
            >
              Save Draft
            </button>

            <button
              onClick={submitQuestionnaire}
              className="px-5 py-3 rounded-xl bg-mpPurple text-white font-semibold hover:opacity-90"
            >
              Create
            </button>
          </div>
        </div>

        {/* Title + Date */}
        <CreateQuestionnaireTitle
          title={title}
          setTitle={setTitle}
          endDate={endDate}
          handleDateChange={setEndDate}
        />

        {/* Preview (read-only cards) */}
        <div className="flex flex-col gap-4 mb-8">
          {questions
            .filter((q) => q.text)
            .map((q) => (
              <DisplayQuestionCard
                key={q.id}
                queId={q.id}
                queType={q.type}
                queText={q.text}
                answersSet={q.answers}
              />
            ))}
        </div>

        {/* Editable Questions */}
        <div className="flex flex-col gap-4">
          {questions.map((question) => (
            <CreateQueBoilerPlateCard
              key={question.id}
              question={question}
              onChange={updateQuestion}
              onRemove={removeQuestion}
            />
          ))}
        </div>

        {/* Add Question */}
        <button
          onClick={addQuestion}
          className="flex items-center gap-2 mt-8 px-6 py-4 rounded-xl bg-mpPurple text-white font-semibold hover:opacity-90"
        >
          <FaRegCircle />
          Add Question
        </button>

        <div className="h-24" />
      </div>
    </div>
  );
};

export default OrganisationCreateQuestionnaire;
